import React from "react";
import "./TileComponent.scss";

const TileComponent = () => {
	return (
		<div className='Main-tile'>
			<h1>Why you should be at Classplus?</h1>
			{/* {window.innerWidth <= 425 && (
				<p>
					You’ll be leading micro-sprints or chasing goals, that we’ve also
					never done before with direct or indirect teammates. For us, personal
					targets are a vanity metric and personal glory is a myth. We live by
					the philosophy of, “With the team, for the team”.
				</p>
			)} */}
			<div className='Main-tile__lists'>
				<div className='Main-tile__lists--firstRow'>
					<div
						className='Main-tile__item Main-tile__item--first'
						data-aos='fade-right'
						data-aos-once='true'
						data-aos-duration='1000'
					>
						<h3 className='Main-tile--heading'>
							Innovate, <br />
							to scale
						</h3>
					</div>
					<div
						className='Main-tile__item Main-tile__item--second'
						data-aos='fade-down'
						data-aos-once='true'
						data-aos-duration='1000'
					>
						<h3 className='Main-tile--heading'>
							Aim for <br /> Moonshots
						</h3>
					</div>
					<div
						className='Main-tile__item Main-tile__item--third'
						data-aos='fade-left'
						data-aos-once='true'
						data-aos-duration='1000'
					>
						<h3 className='Main-tile--heading yourOwnership'>
							Grow with your
							<br /> comrades
						</h3>
					</div>
				</div>

				<div className='Main-tile__lists--secondRow'>
					<div
						className='Main-tile__item Main-tile__item--fourth'
						data-aos='fade-right'
						data-aos-once='true'
						data-aos-duration='1200'
					>
						<h3 className='Main-tile--heading'>
							Celebrate small
							<br />
							victories
						</h3>
					</div>
					<div
						className='Main-tile__item Main-tile__item--fifth'
						data-aos='fade-up'
						data-aos-once='true'
						data-aos-duration='1200'
					>
						<h3 className='Main-tile--heading'>
							Embrace your
							<br />
							unique self
						</h3>
					</div>
					<div
						className='Main-tile__item Main-tile__item--sixth'
						data-aos='fade-left'
						data-aos-once='true'
						data-aos-duration='1200'
					>
						<h3 className='Main-tile--heading'>
							Collaborate <br /> for a purpose
						</h3>
					</div>
				</div>
			</div>
		</div>
	);
};

export default TileComponent;
